module.exports = __webpack_public_path__ + "media/images/singh-f7cba1375f0500f7d1a424886ff85a7e.png";